import React, { useMemo } from 'react';
import { Field, useField } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import CommonDropdown from '../../../components/common-dropdown/CommonDropdown';
import WithError from '../../../components/with-error/WithError';
import WithLabel, { LABEL_STYLES } from '../../../components/with-label/WithLabel';
import useResonanceAgeOptions from '../../../hooks/useResonanceAgeOptions';

import scss from './ResponseForm.module.scss';

function AgeFields({ disabled }) {
  const { t } = useTranslation('scout');

  const ageOptions = useResonanceAgeOptions();
  const { input: ageFromInput } = useField('ageFrom');
  const { input: ageToInput } = useField('ageTo');

  const disabledAgeToOptions = useMemo(
    () =>
      ageOptions.map((age) =>
        ageFromInput.value && age.value < ageFromInput.value
          ? { label: age.label, value: age.value, disabled: true }
          : age,
      ),
    [ageFromInput.value, ageOptions],
  );

  const handleChangeAgeFromField = (newValue) => {
    if (ageToInput.value && newValue > ageToInput.value) {
      ageToInput.onChange(null);
    }

    ageFromInput.onChange(newValue);
  };

  return (
    <>
      <Field name='ageFrom'>
        {({ meta, input }) => (
          <WithLabel variant={LABEL_STYLES.ROW} label={t('ageFrom')} isBold extraClassName={scss.fieldSmall}>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <CommonDropdown
                options={ageOptions}
                value={input.value}
                name={input.name}
                onSelect={handleChangeAgeFromField}
                onBlur={input.onBlur}
                onFocus={input.onFocus}
                isError={meta.touched && meta.error}
                isFilterable
                disabled={disabled}
              />
            </WithError>
          </WithLabel>
        )}
      </Field>

      <Field name='ageTo'>
        {({ meta, input }) => (
          <WithLabel variant={LABEL_STYLES.ROW} label={t('ageTo')} isBold extraClassName={scss.fieldSmall}>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <CommonDropdown
                options={disabledAgeToOptions}
                value={input.value}
                name={input.name}
                onSelect={(newValue) => input.onChange(newValue)}
                onBlur={input.onBlur}
                onFocus={input.onFocus}
                isError={meta.touched && meta.error}
                isFilterable
                disabled={disabled}
              />
            </WithError>
          </WithLabel>
        )}
      </Field>
    </>
  );
}

export default AgeFields;
